import { all } from 'redux-saga/effects';
import authSaga from '@iso/redux/auth/saga';

import companiesSagas from '@iso/redux/company/saga';
import contactsSagas from '@iso/redux/contact/saga';
import ticketsSagas from '@iso/redux/ticket/saga';
import userSaga from '@iso/redux/user/saga';

import templatesSagas from '@iso/redux/template/saga';
import surveysSagas from '@iso/redux/survey/saga';
import clientSurveySagas from '@iso/redux/clientSurvey/saga';
import emailCampaignSagas from '@iso/redux/email-campaign/saga';
import teamSagas from '@iso/redux/team/saga';
import reportsSaga from '@iso/redux/reports/saga';

export default function* rootSaga(getState) {
  yield all([
    authSaga(),
    companiesSagas(),
    contactsSagas(),
    ticketsSagas(),
    userSaga(),
    templatesSagas(),
    surveysSagas(),
    clientSurveySagas(),
    emailCampaignSagas(),
    teamSagas(),
    reportsSaga(),
  ]);
}
